import { ref } from 'vue';
import MasifiConsoleAPI from 'dashboard/api/masifi/masifiConsole';
import store from 'dashboard/store';

// Masifi: ¿este usuario ve el Panel de Control? Un solo GET /console/me por sesión, compartido por el menú y el guard
// de rutas. La fuente de verdad es el backend (cada endpoint revalida el alcance).
const access = ref(null);
const loaded = ref(false);
let inFlight = null;

export const resetControlPanelAccess = () => {
  access.value = null;
  loaded.value = false;
  inFlight = null;
};

// Recursos: solo un SuperAdmin puede tener alcance en F1 → para el resto NO se hace ninguna petición (el payload del
// usuario ya trae `type`). F3 sumará a los miembros de agencia con una marca que viaja en el payload de cuentas.
const canHaveAccess = user => user?.type === 'SuperAdmin';

const load = user => {
  if (loaded.value) return Promise.resolve(access.value);
  if (!canHaveAccess(user)) {
    loaded.value = true;
    access.value = null;
    return Promise.resolve(null);
  }
  if (!inFlight) {
    inFlight = MasifiConsoleAPI.me()
      .then(({ data }) => {
        access.value = data?.scope ? data : null;
      })
      .catch(() => {
        access.value = null;
      })
      .finally(() => {
        loaded.value = true;
      })
      .then(() => access.value);
  }
  return inFlight;
};

export const useControlPanelAccess = () => ({ access, loaded, load });

export const ensureControlPanelAccess = async to => {
  const result = await load(store.getters.getCurrentUser);
  if (result?.scope) return true;
  return { name: 'home', params: { accountId: to.params.accountId } };
};

// Pantallas que solo ve la raíz (SuperAdmin en el dominio maestro), p. ej. Cloudflare: una agencia (F3) tiene alcance
// pero no estas pantallas.
export const ensureControlPanelRoot = async to => {
  const result = await load(store.getters.getCurrentUser);
  if (result?.scope === 'root') return true;
  return { name: 'home', params: { accountId: to.params.accountId } };
};
